import React, { FC } from "react";
import { Outlet, useMatch } from "react-router-dom";
import { APP_LAYOUT_BASE } from "../../utils/menuPathNormalize";
import { HomeShell } from "./HomeShell";

/**
 * `/hub` 嵌套路由父级：访问 `/hub` 仅渲染子路由（index 会跳到子 path），不套 HomeShell；
 * 访问 `/hub/...` 业务子路径时在 HomeShell 内渲染 `<Outlet />`。
 */
export const HomeRootLayout: FC = () => {
  const atLayoutRoot = useMatch({ path: APP_LAYOUT_BASE, end: true });
  if (atLayoutRoot) {
    return <Outlet />;
  }
  return (
    <HomeShell>
      <Outlet />
    </HomeShell>
  );
};
